<template>
    <v-card>
        <v-card-title>{{title}}</v-card-title>
        <v-card-text>
            <v-container fluid>
                <v-row>
                    <v-container fluid>
                        <v-row>
                            <v-col cols="6">
                                <v-text-field label="Nazwa" v-model="searchName" v-on:keypress.enter="refreshTable"></v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <v-text-field label="Opis" v-model="searchDescription" v-on:keypress.enter="refreshTable"></v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <v-checkbox label="Pokazuj tylko prywatne" v-model="onlyPrivates"></v-checkbox>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-combobox
                                        v-model="selectedCategories"
                                        :items="categories"
                                        deletable-chips
                                        label="Kategorie"
                                        item-text="description"
                                        item-value="id"
                                        multiple
                                        chips
                                ></v-combobox>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-spacer></v-spacer>
                                <v-btn color="success" @click="refreshTable()">Szukaj</v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-data-table
                                :options.sync="pagination"
                                :items="items"
                                :loading="loading"
                                :server-items-length="totalResults"
                                :footer-props="{itemsPerPageOptions:[10,20,50,100,200],}"
                                :headers="headers">
                            <template v-slot:item.id="{item}">
                                <v-container fluid>
                                    <v-row>
                                        <v-col>
                                            <v-btn color="primary" @click="closeForm(item)">Wybierz</v-btn>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </template>
                            <template v-slot:item.description="{item}">
                                {{  item.description.length > 50 ? item.description.substring(0,50) + '...' : item.description }}
                            </template>
                            <template v-slot:item.is_private="{item}">
                                {{ item.is_private ? 'Tak' : 'Nie'}}
                            </template>
                            <template v-slot:item.categories="{item}">
                                {{ getCategories(item.categories) }}
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" @click="closeForm(null)">Zamknij</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    import swal from "sweetalert";
    import {descriptionService} from "../../services";

    export default {
        name: "DescriptionPicker",
        props: ["type"],
        data() {
            return {
                title: '',
                loading: true,
                searchName: '',
                searchDescription: '',
                pagination: {},
                onlyPrivates: false,
                selectedCategories: [],
                totalResults: 0,
                items: [],
                categories: [],
                headers: [
                    { text: 'Nazwa', sortable: true, align: 'left', value: 'name'},
                    { text: 'Opis', sortable: true, align: 'left', value: 'description'},
                    { text: 'Prywatny', sortable: true, align: 'left', value: 'is_private'},
                    { text: 'Kategorie', sortable: true, align: 'left', value: 'categories'},
                    { text: '', sortable: false, align: 'right', value: 'id'}
                ]
            }
        },
        methods: {
            closeForm(selected)
            {
                this.$emit('close',selected)
            },
            getCategories(categories)
            {
                if(categories && categories.length > 0)
                {
                    let kategorie = []
                    categories.forEach( elem=> {
                        kategorie.push(elem.description)
                    })
                    return kategorie.join()
                }
                return ''
            },
            showError(close, text) {
                swal({
                    title: "Błąd",
                    text: text,
                    icon: "warning",
                    button: "OK"
                }).then(() => {
                    this.loading = false;
                    if (close) {
                        this.$emit("close");
                    }
                });
            },
            refreshTable()
            {
                if(!this.pagination.itemsPerPage) return
                this.loading = true

                this.requestDescriptions().then(data=> {
                    this.items = data.data.result.items,
                        this.totalResults = data.data.result.totalCount
                    this.loading = false
                }).catch(() => {
                    this.showError(false,'Bład pobierania opisów')
                })
            },
            requestDescriptions() {

                const { sortBy, descending, page, itemsPerPage } = this.pagination
                let isPrivate = null
                let categories = null
                if (this.onlyPrivates)
                {
                    isPrivate = true
                }
                if(this.selectedCategories && this.selectedCategories.length > 0)
                {
                    let cat = []
                    this.selectedCategories.forEach(elem=> {
                        cat.push(elem.id)
                    })
                    categories = cat.join(',')
                }
                let req = descriptionService.getDescriptions({ nameText: this.searchName,descriptionText:this.searchDescription,  SkipCount: (page-1) * itemsPerPage, MaxResultCount: itemsPerPage, sorting: sortBy+(descending ? " DESC": ""),
                    isPrivate: isPrivate,
                    categories: categories,
                    type: this.type
                });
                return req;
            },
        },
        mounted() {
            descriptionService.getAllCategories().then((results) => {
                if(results.data && results.data.result)
                {
                    this.categories = results.data.result
                }
            }).catch(() =>
            {
                this.error("Błąd pobierania kategorii");
            })
        },
        watch: {
            type: {
                immediate: true,
                handler() {
                    if(this.type != null) {
                        this.refreshTable()
                        let typOpisu = '';
                        switch(this.type)
                        {
                            case 0:
                                typOpisu = 'Rozpoznania';
                                break;
                            case 1:
                                typOpisu = 'Zaleceń'
                                break;
                            case 2:
                                typOpisu = "Przebiegu"
                                break;
                        }
                        this.title = "Wybór opisu: "+typOpisu;
                    }
                }
            },
            pagination: {
                handler() {
                    if(this.type != null) {
                        this.requestDescriptions().then(data => {
                            this.items = data.data.result.items,
                                this.totalResults = data.data.result.totalCount
                            this.loading = false
                        }).catch(() => {
                            this.showError(false,'Bład pobierania opisów')
                        })
                    }
                },
                deep: true
            }
        },

    }
</script>

<style scoped>

</style>